module.exports = {
	"wizard": {
		"welcome": "Olá, seja bem vindo a Assinaturas TrayCheckout!",
		"initial_configs": "Vamos ajudá-lo em poucos passos a revisar as configurações iniciais.",
		"btn_lets_start": "Vamos começar",
		"step": {
			"company_data": "Dados da empresa",
			"payments_methods": "Formas de pagamento",
			"conclude": "Concluir",
			"info": "Confirme os dados de contato que serão apresentados para seu assinante na página de contratação de plano.",
			"company_name": "Nome da empresa:",
			"phone": "Telefone:",
			"email": "E-mail:",
			"btn_next": "Ir para formas de pagamento",
			"ph_pegasus_ag": "Agência Pegasus",
			"ph_phone": "Escreva seu telefone",
			"ph_email": "Escreva seu email",
			"configure_payments_title": "Configure as formas de pagamento",
			"configure_payments_text": "<p>Para realizar as cobranças recorrentes será necessário configurar a forma de pagamento boleto sendo necessário informar alguns dados referente a sua conta bancária. Caso ainda não possua estas informações, indicamos que consulte seu banco.</p> <p>Utilizando a Assinaturas TrayCheckout você consegue realizar a configuração de boleto dos seguintes bancos: Banco do Brasil, Bradesco ou Itau Shopline.</p> <p>Para configurar seu boleto após o passo a passo inicial, acesse <strong>CONFIGURAÇÕES > FORMA DE PAGAMENTO</strong>.</p>",
			"back": "Voltar",
			"got_it": "Entendi",
			"endpage_title": "Parabéns, você concluiu a revisão das configurações iniciais",
			"endpage_text": "Agora você deverá criar os planos para que seus clientes realizem a assinatura.",
			"btn_create_plan": "Cadastrar plano",
			"access_address": "Endereço de acesso:",
			"valid_address": "Digite um endereço válido"
		},
		"errors": {
			"invalid_company_name": "Nome da sua empresa",
			"invalid_phone": "Número do telefone",
			"invalid_email": "Digite um e-mail válido",
			"email_cannot_used": "e-mail já cadastrado"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/yaml-loader!./src/lang/wizard/pt-BR.yml
// module id = 596
// module chunks = 1